import { useContext } from 'react'
import { useIntl } from 'react-intl'

import ViewNearbyToursCta from '../../Buttons/ViewNearbyToursCta'

import TextButton from 'LuxKit/Button/TextButton'
import Group from 'components/utils/Group'
import SaveTripItemButton from 'tripPlanner/components/Buttons/SaveTripItemButton'
import LEOfferCTAs from 'tripPlanner/components/ItemCard/Common/LEOfferCTAs'
import useTripPlannerCTALabels from 'tripPlanner/hooks/useTripPlannerCTALabels'
import TripContext from 'tripPlanner/contexts/TripContext'
import type { CruiseItem, TourItem } from 'tripPlanner/types/tripItem'
import type { DetailItemCardVariant } from '../common/types'
import BookedOfferDetailsCTA from './BookedOfferDetailsCTA'
import { addTripIdParam } from 'tripPlanner/utils/url'
import useCanEditTrip from 'tripPlanner/hooks/useCanEditTrip'

interface Props {
  item: Utils.RequiredProp<TourItem, 'savedItemData'> | Utils.RequiredProp<CruiseItem, 'savedItemData'>
  isOfferAvailable: boolean
  variant: DetailItemCardVariant
  offerLink: string
}

function TourCTAContent(props: Props) {
  const intl = useIntl()
  const { isOfferAvailable, item, offerLink, variant } = props
  const { startDate, endDate, tripId } = item

  const canEdit = useCanEditTrip()
  const { viewOfferCopy } = useTripPlannerCTALabels()
  const tripContext = useContext(TripContext)
  const isPublicTrip = tripContext?.isPublicTrip

  if (isPublicTrip) {
    return (
      <Group direction="horizontal" gap={12}>
        <SaveTripItemButton item={item} />
        <TextButton kind="primary" to={offerLink} target="_blank">
          {viewOfferCopy}
        </TextButton>
      </Group>
    )
  } else if (item.isBooked && item.confirmationCode) {
    return <BookedOfferDetailsCTA item={item} size="medium" />
  } else if (!isOfferAvailable) {
    const hasPlannedInfo = !!startDate || !!endDate

    return (
      <Group
        direction="horizontal"
        gap={8}
        tabletHorizontalAlign="space-between"
        horizontalAlign="stretch"
      >
        {hasPlannedInfo && (
          <TextButton
            kind="tertiary"
            to={addTripIdParam(offerLink, tripId, canEdit)}
            target="_blank"
          >
            {intl.formatMessage({
              id: 'pNH5AopnBLcpUd35Mjfi',
              defaultMessage: 'Change details',
              description: 'Button to change booking details for a tour trip item',
            })}
          </TextButton>
        )}
        {item.startPlace.type === 'GEO' && (
          <ViewNearbyToursCta
            item={item}
            lat={item.startPlace.point.lat}
            lng={item.startPlace.point.lng}
            showSearch={variant === 'tripSummary'}
          />
        )}
      </Group>
    )
  } else {
    return <LEOfferCTAs item={item} variant={variant} />
  }
}

export default TourCTAContent
